export default {

// Estansarización de tamaños de letras 
  textSmall: 14,
  textMedium: 18,
  textLarge: 20,
  textMini: 10,
  textXSmall: 15,
  textBase: 16,
  textXl: 28,
  lineHeightBase: 24,

  fontWeightMedium: '500',
  fontWeightLarge: '600',
  fontWeightXl : '1000',
// Estandarización de tamaños de width y height para Image e ImageCache
  imageWidthCardOrigin: .65,     // En CardOriginComponent
  imageHeightCardOrigin: .35, 

  sizeBrainComments: 18, // Tamaño icono cerebro y comments
  sizeTree: 18,
  miniSizeTree: 14,

  imageInMosaic: .32, //Tamaño de los cuadros en el mosaico
};
